<template>
  <div>
    <!-- MUNKASZÜNETI NAPOK FIGYELMEZTETÉS -->
    <b-alert
      v-if="showWorkdayAlert"
      show
      variant="danger"
      class="mb-2 d-flex align-items-center p-1"
    >
      <feather-icon
        icon="AlertCircleIcon"
        size="20"
        class="mr-2"
      />
      <div class="flex-grow-1">
        <strong>Fontos emlékeztető:</strong> Ellenőrizd az idei évre rögzített munkaszüneti napokat, áthelyezett munkanapokat és pihenőnapokat!
      </div>
    </b-alert>

    <!-- FELSŐ STATOK -->
    <b-card
      v-if="data"
      no-body
      class="card-statistics pt-1"
    >
      <b-card-body class="statistics-body">
        <b-row>
          <b-col
            v-for="item in data"
            :key="item.icon"
            xl="3"
            sm="6"
            :class="item.customClass"
          >
            <b-media
              style="cursor:pointer"
              no-body
              @click="show(item.type)"
            >
              <b-media-aside

                class="mr-2"
              >
                <b-avatar
                  size="48"
                  :variant="item.color"
                >
                  <feather-icon
                    size="24"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card
      v-if="data && checkRole('order_menu')"
      no-body
      class="card-statistics pt-1"
    >
      <b-card-body class="statistics-body">
        <b-row>
          <b-col
            v-for="item in data2"
            v-show="checkRole(item.role)"
            :key="item.icon"
            xl="3"
            sm="6"
            :class="item.customClass"
          >
            <b-media
              style="cursor:pointer"
              class="mt-2 mb-2"
              no-body
              @click="show2(item.type)"
            >
              <b-media-aside
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  :variant="item.color"
                >
                  <feather-icon
                    size="24"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card
      v-if="data"
      no-body
      class="card-statistics pt-1"
    >
      <b-card-body class="statistics-body">
        <b-row>
          <b-col
            v-for="item in data3"
            v-show="checkRole(item.role)"
            :key="item.icon"
            xl="3"
            sm="6"
            :class="item.customClass"
          >
            <b-media
              style="cursor:pointer"
              class="mt-2 mb-2"
              no-body
              @click="show2(item.type)"
            >
              <b-media-aside
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  :variant="item.color"
                >
                  <feather-icon
                    size="24"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- JÁRMŰNYILVÁNTARTÁSI FIGYELMEZTETÉSEK -->
    <div
      v-if="(expiredVehicles.length > 0 || soonExpiringVehicles.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <!-- Lejárt forgalmi vizsgás járművek -->
      <div
        v-if="expiredVehicles.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt forgalmi vizsgás ({{ expiredVehicles.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="vehicle in expiredVehicles"
            :key="vehicle.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center mb-1">
                    <div class="font-weight-bold text-danger mb-0 mr-2">
                      {{ vehicle.registration_number }}
                    </div>
                    <span
                      v-if="vehicle.next_service_type"
                      class="badge"
                      :class="vehicle.next_service_type === 'official' ? 'badge-warning' : 'badge-secondary'"
                    >
                      {{ vehicle.next_service_type === 'official' ? 'Hivatalos szervíz' : 'Belső szervíz' }}
                    </span>
                  </div>
                  <small class="text-muted d-block">
                    {{ vehicle.manufacture }} {{ vehicle.variety }}
                  </small>
                  <small class="text-dark">
                    {{ vehicle.driver || 'Nincs sofőr' }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold">
                    {{ formatDate(vehicle.technical_validity) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Hamarosan lejáró forgalmi vizsgás járművek -->
      <div
        v-if="soonExpiringVehicles.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="text-warning mr-2"
          />
          <h6 class="mb-0 text-warning font-weight-bold">
            Hamarosan lejáró forgalmi vizsgás járművek ({{ soonExpiringVehicles.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="vehicle in soonExpiringVehicles"
            :key="vehicle.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-warning mb-0">
                    {{ vehicle.registration_number }}
                  </div>
                  <small class="text-muted d-block">
                    {{ vehicle.manufacture }} {{ vehicle.variety }}
                  </small>
                  <small class="text-dark">
                    {{ vehicle.driver || 'Nincs sofőr' }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-warning font-weight-bold">
                    {{ formatDate(vehicle.technical_validity) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BIZTOSÍTÁSI FIGYELMEZTETÉSEK -->
    <div
      v-if="(expiredInsurances.length > 0 || soonExpiringInsurances.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <!-- Lejárt biztosítású járművek -->
      <div
        v-if="expiredInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt biztosítású járművek ({{ expiredInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in expiredInsurances"
            :key="insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-danger mb-0">
                    {{ (insurance.car && insurance.car.registration_number) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.car && insurance.car.manufacture }} {{ insurance.car && insurance.car.variety }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Hamarosan lejáró biztosítású járművek -->
      <div
        v-if="soonExpiringInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="text-warning mr-2"
          />
          <h6 class="mb-0 text-warning font-weight-bold">
            Hamarosan lejáró biztosítások ({{ soonExpiringInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in soonExpiringInsurances"
            :key="insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-warning mb-0">
                    {{ (insurance.car && insurance.car.registration_number) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.car && insurance.car.manufacture }} {{ insurance.car && insurance.car.variety }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-warning font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SZERVÍZ FIGYELMEZTETÉSEK -->
    <!-- MUNKAGEP BIZTOSITASI FIGYELMEZTETESEK -->
    <div
      v-if="(expiredWorkMachineInsurances.length > 0 || soonExpiringWorkMachineInsurances.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <div
        v-if="expiredWorkMachineInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt biztosítású munkagépek ({{ expiredWorkMachineInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in expiredWorkMachineInsurances"
            :key="'expired-work-machine-insurance-' + insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-danger mb-0">
                    {{ (insurance.work_machine && insurance.work_machine.name) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.work_machine && insurance.work_machine.brand }} {{ insurance.work_machine && insurance.work_machine.type }}
                  </small>
                  <small class="text-dark d-block">
                    Rendszám: {{ (insurance.work_machine && insurance.work_machine.registration_number) || 'N/A' }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="soonExpiringWorkMachineInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="text-warning mr-2"
          />
          <h6 class="mb-0 text-warning font-weight-bold">
            Hamarosan lejáró munkagép biztosítások ({{ soonExpiringWorkMachineInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in soonExpiringWorkMachineInsurances"
            :key="'soon-work-machine-insurance-' + insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-warning mb-0">
                    {{ (insurance.work_machine && insurance.work_machine.name) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.work_machine && insurance.work_machine.brand }} {{ insurance.work_machine && insurance.work_machine.type }}
                  </small>
                  <small class="text-dark d-block">
                    Rendszám: {{ (insurance.work_machine && insurance.work_machine.registration_number) || 'N/A' }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-warning font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- EMELOGEP BIZTOSITASI FIGYELMEZTETESEK -->
    <div
      v-if="(expiredLiftingMachineInsurances.length > 0 || soonExpiringLiftingMachineInsurances.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <div
        v-if="expiredLiftingMachineInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt biztosítású emelőgépek ({{ expiredLiftingMachineInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in expiredLiftingMachineInsurances"
            :key="'expired-lifting-machine-insurance-' + insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-danger mb-0">
                    {{ (insurance.lifting_machine && insurance.lifting_machine.name) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.lifting_machine && insurance.lifting_machine.brand }} {{ insurance.lifting_machine && insurance.lifting_machine.type }}
                  </small>
                  <small class="text-dark d-block">
                    Rendszám: {{ (insurance.lifting_machine && insurance.lifting_machine.registration_number) || 'N/A' }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="soonExpiringLiftingMachineInsurances.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="text-warning mr-2"
          />
          <h6 class="mb-0 text-warning font-weight-bold">
            Hamarosan lejáró emelőgép biztosítások ({{ soonExpiringLiftingMachineInsurances.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="insurance in soonExpiringLiftingMachineInsurances"
            :key="'soon-lifting-machine-insurance-' + insurance.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-warning mb-0">
                    {{ (insurance.lifting_machine && insurance.lifting_machine.name) || 'N/A' }}
                  </div>
                  <small class="text-muted d-block">
                    {{ insurance.lifting_machine && insurance.lifting_machine.brand }} {{ insurance.lifting_machine && insurance.lifting_machine.type }}
                  </small>
                  <small class="text-dark d-block">
                    Rendszám: {{ (insurance.lifting_machine && insurance.lifting_machine.registration_number) || 'N/A' }}
                  </small>
                  <small class="text-dark d-block">
                    {{ insurance.insurance_name }}
                  </small>
                  <small class="text-dark">
                    {{ insurance.policy_number }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-warning font-weight-bold">
                    {{ formatDate(insurance.expiry_date) }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="(expiredServiceVehicles.length > 0 || soonServiceVehicles.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <!-- Lejárt szervízű járművek -->
      <div
        v-if="expiredServiceVehicles.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt szervízű járművek ({{ expiredServiceVehicles.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="vehicle in expiredServiceVehicles"
            :key="'expired-service-' + vehicle.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center mb-1">
                    <div class="font-weight-bold text-danger mb-0 mr-2">
                      {{ vehicle.registration_number }}
                    </div>
                    <span
                      class="badge"
                      :class="vehicle.service_type === 'official' ? 'badge-warning' : 'badge-secondary'"
                    >
                      {{ vehicle.service_type === 'official' ? 'Hivatalos szervíz' : 'Nem hivatalos szervíz' }}
                    </span>
                  </div>
                  <small class="text-muted d-block">
                    {{ vehicle.manufacture }} {{ vehicle.variety }}
                  </small>
                  <small class="text-dark d-block">
                    {{ vehicle.driver || 'Nincs sofőr' }}
                  </small>
                  <small class="text-dark d-block">
                    Jelenlegi km: {{ formatNumber(vehicle.odometer) }}
                  </small>
                  <small class="text-muted d-block">
                    Szervíz esedékes: {{ formatNumber(vehicle.next_service_odometer) }} km
                  </small>
                  <small
                    v-if="vehicle.remaining_days !== null && vehicle.remaining_days !== undefined"
                    class="text-muted"
                  >
                    ({{ vehicle.remaining_days }} nap)
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold d-block">
                    {{ formatNumber(vehicle.serviceOverdueKm) }} km
                  </small>
                  <small class="text-danger">
                    késésben
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 21 napon belül esedékes szervízek -->
      <div
        v-if="soonServiceVehicles.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ToolIcon"
            size="18"
            class="text-info mr-2"
          />
          <h6 class="mb-0 text-info font-weight-bold">
            Hamarosan esedékes szervízek ({{ soonServiceVehicles.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="vehicle in soonServiceVehicles"
            :key="'service-' + vehicle.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-info mb-0 py-2 px-3 border-left-4 border-info shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center mb-1">
                    <div class="font-weight-bold text-info mb-0 mr-2">
                      {{ vehicle.registration_number }}
                    </div>
                    <span
                      class="badge"
                      :class="vehicle.service_type === 'official' ? 'badge-warning' : 'badge-secondary'"
                    >
                      {{ vehicle.service_type === 'official' ? 'Hivatalos szervíz' : 'Nem hivatalos szervíz' }}
                    </span>
                  </div>
                  <small class="text-muted d-block">
                    {{ vehicle.manufacture }} {{ vehicle.variety }}
                  </small>
                  <small class="text-dark d-block">
                    {{ vehicle.driver || 'Nincs sofőr' }}
                  </small>
                  <small class="text-dark d-block">
                    Jelenlegi km: {{ formatNumber(vehicle.odometer) }}
                  </small>
                  <small class="text-muted d-block">
                    Szervíz esedékes: {{ formatNumber(vehicle.next_service_odometer) }} km
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-info font-weight-bold d-block">
                    {{ formatNumber(vehicle.serviceRemainingKm) }} km maradt
                  </small>
                  <small
                    v-if="vehicle.remaining_days !== null && vehicle.remaining_days !== undefined"
                    class="text-muted"
                  >
                    (kb {{ vehicle.remaining_days }} nap)
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- GÉPEK SZERVÍZ FIGYELMEZTETÉSEK -->

    <!-- Lejárt szervízű aggregátorok -->
    <div
      v-if="expiredAggregators.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="AlertTriangleIcon"
          size="18"
          class="text-danger mr-2"
        />
        <h6 class="mb-0 text-danger font-weight-bold">
          Lejárt szervízű aggregátorok ({{ expiredAggregators.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in expiredAggregators"
          :key="'expired-aggregator-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="ZapIcon"
                    size="16"
                    class="text-danger mr-2"
                  />
                  <div class="font-weight-bold text-danger mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-danger">
                    {{ machine.serviceOverdueDays }} napja lejárt
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-danger font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.operating_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lejárt szervízű munkagépek -->
    <div
      v-if="expiredWorkMachines.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="AlertTriangleIcon"
          size="18"
          class="text-danger mr-2"
        />
        <h6 class="mb-0 text-danger font-weight-bold">
          Lejárt szervízű munkagépek ({{ expiredWorkMachines.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in expiredWorkMachines"
          :key="'expired-work-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="TruckIcon"
                    size="16"
                    class="text-danger mr-2"
                  />
                  <div class="font-weight-bold text-danger mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-danger">
                    {{ machine.serviceOverdueDays }} napja lejárt
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-danger font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.current_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lejárt szervízű emelőgépek -->
    <div
      v-if="expiredLiftingMachines.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="AlertTriangleIcon"
          size="18"
          class="text-danger mr-2"
        />
        <h6 class="mb-0 text-danger font-weight-bold">
          Lejárt szervízű emelőgépek ({{ expiredLiftingMachines.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in expiredLiftingMachines"
          :key="'expired-lifting-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="TrendingUpIcon"
                    size="16"
                    class="text-danger mr-2"
                  />
                  <div class="font-weight-bold text-danger mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-danger">
                    {{ machine.serviceOverdueDays }} napja lejárt
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-danger font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.current_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamarosan esedékes szervízű aggregátorok -->
    <div
      v-if="soonAggregators.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="ToolIcon"
          size="18"
          class="text-info mr-2"
        />
        <h6 class="mb-0 text-info font-weight-bold">
          Hamarosan esedékes aggregátorok szervize ({{ soonAggregators.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in soonAggregators"
          :key="'soon-aggregator-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-info mb-0 py-2 px-3 border-left-4 border-info shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="ZapIcon"
                    size="16"
                    class="text-info mr-2"
                  />
                  <div class="font-weight-bold text-info mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-info">
                    {{ machine.remaining_days }} nap múlva
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-info font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.operating_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamarosan esedékes szervízű munkagépek -->
    <div
      v-if="soonWorkMachines.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="ToolIcon"
          size="18"
          class="text-info mr-2"
        />
        <h6 class="mb-0 text-info font-weight-bold">
          Hamarosan esedékes munkagépek szervize ({{ soonWorkMachines.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in soonWorkMachines"
          :key="'soon-work-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-info mb-0 py-2 px-3 border-left-4 border-info shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="TruckIcon"
                    size="16"
                    class="text-info mr-2"
                  />
                  <div class="font-weight-bold text-info mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-info">
                    {{ machine.remaining_days }} nap múlva
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-info font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.current_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamarosan esedékes szervízű emelőgépek -->
    <div
      v-if="soonLiftingMachines.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="ToolIcon"
          size="18"
          class="text-info mr-2"
        />
        <h6 class="mb-0 text-info font-weight-bold">
          Hamarosan esedékes emelőgépek szervize ({{ soonLiftingMachines.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in soonLiftingMachines"
          :key="'soon-lifting-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-info mb-0 py-2 px-3 border-left-4 border-info shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    icon="TrendingUpIcon"
                    size="16"
                    class="text-info mr-2"
                  />
                  <div class="font-weight-bold text-info mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-info">
                    {{ machine.remaining_days }} nap múlva
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-info font-weight-bold d-block">
                  Szervíz: {{ formatNumber(machine.next_service_hours) }} óra
                </small>
                <small class="text-muted d-block">
                  Jelenlegi: {{ formatNumber(machine.current_hours) }} óra
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OLAJCSERE FIGYELMEZTETÉSEK -->

    <!-- Lejárt olajcserék -->
    <div
      v-if="expiredOilChanges.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="AlertOctagonIcon"
          size="18"
          class="text-danger mr-2"
        />
        <h6 class="mb-0 text-danger font-weight-bold">
          Lejárt olajcserék ({{ expiredOilChanges.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in expiredOilChanges"
          :key="'expired-oil-' + machine.machine_type + '-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    :icon="getMachineTypeIcon(machine.machine_type)"
                    size="16"
                    class="text-danger mr-2"
                  />
                  <div class="font-weight-bold text-danger mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ getMachineTypeName(machine.machine_type) }} - {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-danger">
                    <feather-icon
                      icon="DropletIcon"
                      size="12"
                      class="mr-1"
                    />
                    {{ Math.abs(machine.oil_change_days_remaining) }} napja lejárt
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-danger font-weight-bold d-block">
                  Utolsó csere: {{ formatDate(machine.oil_change_date) }}
                </small>
                <small class="text-muted d-block">
                  Esedékes volt: {{ formatDate(machine.oil_change_due_date) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamarosan esedékes olajcserék -->
    <div
      v-if="soonOilChanges.length > 0 && checkRole('car_menu')"
      class="mb-3"
    >
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          icon="DropletIcon"
          size="18"
          class="text-warning mr-2"
        />
        <h6 class="mb-0 text-warning font-weight-bold">
          Hamarosan esedékes olajcserék ({{ soonOilChanges.length }} db)
        </h6>
      </div>
      <div class="row">
        <div
          v-for="machine in soonOilChanges"
          :key="'soon-oil-' + machine.machine_type + '-' + machine.id"
          class="col-lg-4 col-md-6 mb-2"
        >
          <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
            <div class="d-flex justify-content-between align-items-start">
              <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                    :icon="getMachineTypeIcon(machine.machine_type)"
                    size="16"
                    class="text-warning mr-2"
                  />
                  <div class="font-weight-bold text-warning mb-0">
                    {{ machine.name || 'N/A' }}
                  </div>
                </div>
                <small class="text-muted d-block">
                  {{ getMachineTypeName(machine.machine_type) }} - {{ machine.brand }} {{ machine.type }}
                </small>
                <div class="mt-1">
                  <span class="badge badge-warning">
                    <feather-icon
                      icon="DropletIcon"
                      size="12"
                      class="mr-1"
                    />
                    {{ machine.oil_change_days_remaining }} nap múlva
                  </span>
                </div>
              </div>
              <div class="text-right ml-2">
                <small class="text-warning font-weight-bold d-block">
                  Utolsó csere: {{ formatDate(machine.oil_change_date) }}
                </small>
                <small class="text-muted d-block">
                  Esedékes: {{ formatDate(machine.oil_change_due_date) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TORONY DARU VIZSGÁLATI FIGYELMEZTETÉSEK -->
    <div
      v-if="(expiredTowerCraneInspections.length > 0 || soonExpiringTowerCraneInspections.length > 0) && checkRole('car_menu')"
      class="mb-3"
    >
      <!-- Lejárt szerkezeti vizsgák -->
      <div
        v-if="expiredTowerCraneInspections.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="AlertTriangleIcon"
            size="18"
            class="text-danger mr-2"
          />
          <h6 class="mb-0 text-danger font-weight-bold">
            Lejárt szerkezeti vizsgájú torony daruk ({{ expiredTowerCraneInspections.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="inspection in expiredTowerCraneInspections"
            :key="inspection.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-danger mb-0 py-2 px-3 border-left-4 border-danger shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-danger mb-0">
                    {{ inspection.tower_crane.name }}
                  </div>
                  <small class="text-muted d-block">
                    {{ inspection.tower_crane.brand }} {{ inspection.tower_crane.type }}
                  </small>
                  <small class="text-dark d-block">
                    Felszerelve: {{ formatDate(inspection.date_of_installation) }}
                  </small>
                  <small class="text-dark">
                    Helyszín: {{ inspection.building }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-danger font-weight-bold">
                    {{ inspection.nextInspectionDate }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Hamarosan lejáró szerkezeti vizsgák -->
      <div
        v-if="soonExpiringTowerCraneInspections.length > 0"
        class="mb-3"
      >
        <div class="d-flex align-items-center mb-2">
          <feather-icon
            icon="ClockIcon"
            size="18"
            class="text-warning mr-2"
          />
          <h6 class="mb-0 text-warning font-weight-bold">
            Szerkezeti vizsgát igénylő torony daruk ({{ soonExpiringTowerCraneInspections.length }} db)
          </h6>
        </div>
        <div class="row">
          <div
            v-for="inspection in soonExpiringTowerCraneInspections"
            :key="inspection.id"
            class="col-lg-4 col-md-6 mb-2"
          >
            <div class="alert alert-warning mb-0 py-2 px-3 border-left-4 border-warning shadow-sm">
              <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1">
                  <div class="font-weight-bold text-warning mb-0">
                    {{ inspection.tower_crane.name }}
                  </div>
                  <small class="text-muted d-block">
                    {{ inspection.tower_crane.brand }} {{ inspection.tower_crane.type }}
                  </small>
                  <small class="text-dark d-block">
                    Felszerelve: {{ formatDate(inspection.date_of_installation) }}
                  </small>
                  <small class="text-dark">
                    Helyszín: {{ inspection.building }}
                  </small>
                </div>
                <div class="text-right ml-2">
                  <small class="text-warning font-weight-bold">
                    {{ inspection.nextInspectionDate }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="row">
      <div class="col-lg-12">
        <table-list :rows="rows" class="w-100 table-list-box" />
      </div>-->
    <!--<div class="col-lg-4">
        <pie-chart class="w-100" />
      </div>-->
  </div>
  <!-- TÁBLA BENNE A LEJÁRÓ -->
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BCardBody, BMedia, BMediaAside, BMediaBody, BAvatar, BAlert,
} from 'bootstrap-vue'
import axios from 'axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BAlert,
  },
  data() {
    return {
      data3: [
        {
          icon: 'UserIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Függőben lévő szabadság elbírálás',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.freeday.own',
          role: 'foreman_freeday',
        },
        {
          icon: 'UserIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Függőben lévő szabadság elbírálás',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.freeday.own.leader',
          role: 'leader_freeday',
        },
      ],
      data2: [
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Rendeléseim',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.own',
          role: 'create_order',
        },
        {
          icon: 'ClockIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Haramosan lejáró rendelések',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.list.list',
          role: 'delivery_offer',
        },
        {
          icon: 'TruckIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Kiküldött rendelések',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.list.list',
          role: 'delivery_offer',
        },
        {
          icon: 'CheckSquareIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Visszaigazolt rendelések',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.list.list',
          role: 'delivery_offer',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Beérkezett rendelések',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.list.list',
          role: 'delivery_offer',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Visszaigazolásra váró rendelések',
          customClass: 'mb-2 mb-xl-0',
          type: 'monolit.order.list.list',
          role: 'accept_order',
        },
      ],
      data: [
        {
          icon: 'TrendingUpIcon',
          color: 'light-primary',
          title: '? darab',
          subtitle: 'Feladataim',
          customClass: 'mb-2 mb-xl-0',
          type: 'Feladataim',
        },
        {
          icon: 'ClockIcon',
          color: 'light-warning',
          title: '? darab',
          subtitle: 'Hamarosan lejáró',
          customClass: 'mb-2 mb-xl-0',
          type: 'Hamarosan_lejáró',
        },
        {
          icon: 'AlertCircleIcon',
          color: 'light-danger',
          title: '? darab',
          subtitle: 'Lejárt határidők',
          customClass: 'mb-2 mb-sm-0',
          type: 'Késésben_lévő',
        },
        {
          icon: 'FileTextIcon',
          color: 'light-success',
          title: '? darab',
          subtitle: 'Kiadott feladatok',
          customClass: '',
          type: 'Kiadott',
        },
      ],
      rows: [],
      vehicleInspections: [],
      expiredVehicles: [],
      soonExpiringVehicles: [],
      vehicleInsurances: [],
      expiredInsurances: [],
      soonExpiringInsurances: [],
      workMachineInsurances: [],
      expiredWorkMachineInsurances: [],
      soonExpiringWorkMachineInsurances: [],
      liftingMachineInsurances: [],
      expiredLiftingMachineInsurances: [],
      soonExpiringLiftingMachineInsurances: [],
      towerCraneInspections: [],
      expiredTowerCraneInspections: [],
      soonExpiringTowerCraneInspections: [],
      vehicleServices: [],
      expiredServiceVehicles: [],
      soonServiceVehicles: [],
      machineServices: [],
      expiredAggregators: [],
      soonAggregators: [],
      expiredWorkMachines: [],
      soonWorkMachines: [],
      expiredLiftingMachines: [],
      soonLiftingMachines: [],
      expiredOilChanges: [],
      soonOilChanges: [],
    }
  },
  computed: {
    showWorkdayAlert() {
      // Ellenőrizzük a jogosultságot
      if (!this.checkRole('workday_calendar')) {
        return false
      }

      // Ellenőrizzük a dátumot (január 1-15)
      const today = new Date()
      const month = today.getMonth() + 1 // 1-12
      const day = today.getDate()

      return month === 1 && day >= 1 && day <= 15
    },
  },
  mounted() {
    axios({
      method: 'get',
      url: 'stat/list',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }).then(res => {
      this.data[0].title = `${res.data.basic_stat.given_task} darab`
      this.data[1].title = `${res.data.basic_stat.coming_soon_out_of_date} darab`
      this.data[2].title = `${res.data.basic_stat.out_of_date} darab`
      this.data[3].title = `${res.data.basic_stat.assigned_task} darab`

      this.data2[0].title = `${res.data.order_stat.my_orders} darab`
      this.data2[1].title = `${res.data.order_stat.orders_3_days} darab`
      this.data2[2].title = `${res.data.order_stat.accepted_warehouse} darab`
      this.data2[3].title = `${res.data.order_stat.completed_orders} darab`
      this.data2[4].title = `${res.data.order_stat.accepted_offer} darab`
      this.data2[5].title = `${res.data.order_stat.review_order} darab`

      this.rows = res.data.my_tasks

      // Process vehicle inspection data
      if (res.data.vehicle_inspection) {
        this.vehicleInspections = res.data.vehicle_inspection
        this.processVehicleInspections()
      }

      // Process vehicle insurance data
      if (res.data.vehicle_insurance) {
        this.vehicleInsurances = res.data.vehicle_insurance
        this.processVehicleInsurances()
      }

      if (res.data.work_machine_insurance) {
        this.workMachineInsurances = res.data.work_machine_insurance
        this.processWorkMachineInsurances()
      }

      if (res.data.lifting_machine_insurance) {
        this.liftingMachineInsurances = res.data.lifting_machine_insurance
        this.processLiftingMachineInsurances()
      }

      // Process tower crane inspection data
      if (res.data.tower_crane_inspection) {
        this.towerCraneInspections = res.data.tower_crane_inspection
        this.processTowerCraneInspections()
      }

      // Process vehicle service data
      if (res.data.car_service_due) {
        this.vehicleServices = res.data.car_service_due
        this.processVehicleServices()
      }

      // Process machine service data
      if (res.data.machine_service_due) {
        this.machineServices = res.data.machine_service_due
        this.processMachineServices()
      }
    })

    axios({
      method: 'get',
      url: 'freeday/list/leader/waiting',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }).then(res => {
      this.data3[1].title = `${res.data} darab`
    })

    axios({
      method: 'get',
      url: 'freeday/list/foreman/waiting',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }).then(res => {
      this.data3[0].title = `${res.data} darab`
    })
  },
  methods: {
    checkRole(roles) {
      return JSON.parse(localStorage.getItem('user')).role.includes(roles)
    },
    show(type) {
      this.$router.push({ name: 'monolit.global.todo.filter', params: { filter: type } })
    },
    show2(type) {
      this.$router.push({ name: type })
    },
    processVehicleInspections() {
      const today = new Date()
      const warningPeriod = 15

      this.expiredVehicles = []
      this.soonExpiringVehicles = []

      this.vehicleInspections.forEach(vehicle => {
        if (vehicle.technical_validity) {
          const expiryDate = new Date(vehicle.technical_validity)
          const timeDiff = expiryDate.getTime() - today.getTime()
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

          if (daysDiff < 0) {
            // Lejárt
            this.expiredVehicles.push(vehicle)
          } else if (daysDiff <= warningPeriod) {
            this.soonExpiringVehicles.push(vehicle)
          }
        }
      })
    },
    processVehicleInsurances() {
      const today = new Date()
      const warningPeriod = 50

      this.expiredInsurances = []
      this.soonExpiringInsurances = []

      this.vehicleInsurances.forEach(insurance => {
        if (insurance.expiry_date) {
          const expiryDate = new Date(insurance.expiry_date)
          const timeDiff = expiryDate.getTime() - today.getTime()
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

          if (daysDiff < 0) {
            // Lejárt
            this.expiredInsurances.push(insurance)
          } else if (daysDiff <= warningPeriod) {
            this.soonExpiringInsurances.push(insurance)
          }
        }
      })
    },
    processWorkMachineInsurances() {
      const today = new Date()
      const warningPeriod = 50

      this.expiredWorkMachineInsurances = []
      this.soonExpiringWorkMachineInsurances = []

      this.workMachineInsurances.forEach(insurance => {
        if (insurance.expiry_date) {
          const expiryDate = new Date(insurance.expiry_date)
          const timeDiff = expiryDate.getTime() - today.getTime()
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

          if (daysDiff < 0) {
            this.expiredWorkMachineInsurances.push(insurance)
          } else if (daysDiff <= warningPeriod) {
            this.soonExpiringWorkMachineInsurances.push(insurance)
          }
        }
      })
    },
    processLiftingMachineInsurances() {
      const today = new Date()
      const warningPeriod = 50

      this.expiredLiftingMachineInsurances = []
      this.soonExpiringLiftingMachineInsurances = []

      this.liftingMachineInsurances.forEach(insurance => {
        if (insurance.expiry_date) {
          const expiryDate = new Date(insurance.expiry_date)
          const timeDiff = expiryDate.getTime() - today.getTime()
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

          if (daysDiff < 0) {
            this.expiredLiftingMachineInsurances.push(insurance)
          } else if (daysDiff <= warningPeriod) {
            this.soonExpiringLiftingMachineInsurances.push(insurance)
          }
        }
      })
    },
    processTowerCraneInspections() {
      const today = new Date()
      const warningPeriod = 15 // 15 nappal a lejárat előtt

      this.expiredTowerCraneInspections = []
      this.soonExpiringTowerCraneInspections = []

      this.towerCraneInspections.forEach(inspection => {
        // Csak az aktív (felszerelt) darukat nézzük
        if (!inspection.is_active) {
          return
        }

        let baseDate

        // Ha van periodic_inspection, az utolsó vizsgálat dátumát használjuk
        if (inspection.periodic_inspection && inspection.periodic_inspection.length > 0) {
          const latestInspection = inspection.periodic_inspection[inspection.periodic_inspection.length - 1]
          baseDate = new Date(latestInspection.review_date)
        } else {
          // Ha nincs vizsgálat, a felszerelés dátumát használjuk
          baseDate = new Date(inspection.date_of_installation)
        }

        // Következő vizsgálat dátuma: baseDate + 8 hónap
        const nextInspectionDate = new Date(baseDate)
        nextInspectionDate.setMonth(nextInspectionDate.getMonth() + 8)

        // Számoljuk ki hány nap van hátra
        const timeDiff = nextInspectionDate.getTime() - today.getTime()
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

        // Formázzuk a dátumot YYYY-MM-DD formátumra
        const formattedNextDate = nextInspectionDate.toISOString().split('T')[0]

        // Hozzáadjuk a következő vizsgálat dátumát az objektumhoz
        const inspectionWithDate = {
          ...inspection,
          nextInspectionDate: formattedNextDate,
        }

        if (daysDiff < 0) {
          // Lejárt
          this.expiredTowerCraneInspections.push(inspectionWithDate)
        } else if (daysDiff <= warningPeriod) {
          // Hamarosan lejár (15 napon belül)
          this.soonExpiringTowerCraneInspections.push(inspectionWithDate)
        }
      })
    },
    processVehicleServices() {
      // Azon járművek szűrése, amelyeknél 21 napon belül (3 hét * 150 km/hét = 3150 km) esedékes a szervíz
      const serviceWarningKm = 3150

      this.expiredServiceVehicles = []
      this.soonServiceVehicles = []

      this.vehicleServices.forEach(vehicle => {
        if (vehicle.next_service_odometer !== null && vehicle.next_service_odometer !== undefined && vehicle.odometer !== null && vehicle.odometer !== undefined) {
          const remainingKm = vehicle.next_service_odometer - vehicle.odometer

          if (remainingKm < 0) {
            // Lejárt szervíz (odometer > next_service_odometer)
            this.expiredServiceVehicles.push({
              ...vehicle,
              serviceOverdueKm: Math.abs(remainingKm),
            })
          } else if (remainingKm <= serviceWarningKm) {
            // Hamarosan esedékes (remaining km <= 3150 km)
            this.soonServiceVehicles.push({
              ...vehicle,
              serviceRemainingKm: remainingKm,
            })
          }
        }
      })

      // Rendezés: lejártnál a legnagyobb túllépés elől, hamarosannál a legkevesebb km elöl
      this.expiredServiceVehicles.sort((a, b) => b.serviceOverdueKm - a.serviceOverdueKm)
      this.soonServiceVehicles.sort((a, b) => a.serviceRemainingKm - b.serviceRemainingKm)
    },
    processMachineServices() {
      this.expiredAggregators = []
      this.soonAggregators = []
      this.expiredWorkMachines = []
      this.soonWorkMachines = []
      this.expiredLiftingMachines = []
      this.soonLiftingMachines = []
      this.expiredOilChanges = []
      this.soonOilChanges = []

      this.machineServices.forEach(machine => {
        if (machine.remaining_days !== null && machine.remaining_days !== undefined) {
          const machineWithOverdue = {
            ...machine,
            serviceOverdueDays: Math.abs(machine.remaining_days),
          }

          if (machine.remaining_days <= 0) {
            // Lejárt szervíz - géptípus szerint
            if (machine.machine_type === 'aggregator') {
              this.expiredAggregators.push(machineWithOverdue)
            } else if (machine.machine_type === 'work_machine') {
              this.expiredWorkMachines.push(machineWithOverdue)
            } else if (machine.machine_type === 'lifting_machine') {
              this.expiredLiftingMachines.push(machineWithOverdue)
            }
          } else if (machine.remaining_days <= 21) {
            // Hamarosan esedékes (21 napon belül)
            if (machine.machine_type === 'aggregator') {
              this.soonAggregators.push(machine)
            } else if (machine.machine_type === 'work_machine') {
              this.soonWorkMachines.push(machine)
            } else if (machine.machine_type === 'lifting_machine') {
              this.soonLiftingMachines.push(machine)
            }
          }
        }

        // Olajcsere ellenőrzés
        if (machine.oil_change_status) {
          if (machine.oil_change_status === 'expired') {
            this.expiredOilChanges.push(machine)
          } else if (machine.oil_change_status === 'due_soon') {
            this.soonOilChanges.push(machine)
          }
        }
      })

      // Rendezés
      this.expiredAggregators.sort((a, b) => b.serviceOverdueDays - a.serviceOverdueDays)
      this.soonAggregators.sort((a, b) => a.remaining_days - b.remaining_days)
      this.expiredWorkMachines.sort((a, b) => b.serviceOverdueDays - a.serviceOverdueDays)
      this.soonWorkMachines.sort((a, b) => a.remaining_days - b.remaining_days)
      this.expiredLiftingMachines.sort((a, b) => b.serviceOverdueDays - a.serviceOverdueDays)
      this.soonLiftingMachines.sort((a, b) => a.remaining_days - b.remaining_days)

      // Olajcserék rendezése
      this.expiredOilChanges.sort((a, b) => a.oil_change_days_remaining - b.oil_change_days_remaining)
      this.soonOilChanges.sort((a, b) => a.oil_change_days_remaining - b.oil_change_days_remaining)
    },
    getMachineTypeName(type) {
      const typeNames = {
        aggregator: 'Aggregátor',
        work_machine: 'Munkagép',
        lifting_machine: 'Emelőgép',
      }
      return typeNames[type] || 'Gép'
    },
    getMachineTypeIcon(type) {
      const icons = {
        aggregator: 'ZapIcon',
        work_machine: 'TruckIcon',
        lifting_machine: 'TrendingUpIcon',
      }
      return icons[type] || 'ToolIcon'
    },
    formatDate(dateString) {
      if (!dateString) return 'Nincs megadva'

      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    formatNumber(number) {
      if (!number && number !== 0) return 'N/A'
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
  },
}
</script>

<style scoped>
.border-left-4 {
  border-left: 4px solid !important;
}

.border-danger {
  border-left-color: #dc3545 !important;
}

.border-warning {
  border-left-color: #ffc107 !important;
}

.border-info {
  border-left-color: #17a2b8 !important;
}
</style>
